import { useEffect, useState } from 'react'
import IonIcon from '@reacticons/ionicons'
import { getusersubscription } from '../../../services/data'
import Loader from '../../../components/loader'
import validateJSON from '../../../util/jsonvalidation'
import Cookies from 'js-cookie'
import { useAuth } from '../../../context/logincontext'
import { useLocation, useParams } from 'react-router-dom'

const LogsComponent = () => {
  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const { userdata } = useAuth()

  // const store_id = localStorage.getItem('store_id')
  const user_id = validateJSON(userdata)
  // const user_id = validateJSON(userdata).id
  // const user_id = validateJSON(Cookies.get('user'))
  const limit = 10

  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  useEffect(() => {
    const getUserSubscriptionList = async () => {
      setLoading(true)
      try {
        // Pass the currentPage as the 'page' keyword
        const res = await getusersubscription(
          '',
          '',
          '',
          store_id,
          '',
          currentPage // Updated to currentPage
        )
        if (res?.data?.length) {
          setSubscriptions(res.data)
          setTotalItems(res?.pagination?.total || 0)
          setTotalPages(Math.ceil(res?.pagination?.total / limit)) // Calculate the total number of pages
        } else {
          setSubscriptions([])
        }
      } catch (err) {
        console.error('Failed to fetch subscriptions', err)
        setSubscriptions([])
      } finally {
        setLoading(false)
      }
    }

    getUserSubscriptionList()
    const handleCustomRefresh = () => {
      getUserSubscriptionList()
    }

    window.addEventListener('refresh-subscription-logs', handleCustomRefresh)

    return () => {
      window.removeEventListener(
        'refresh-subscription-logs',
        handleCustomRefresh
      )
    }
  }, [currentPage])

  const handlePageChange = direction => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1)
    } else if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const startItem = (currentPage - 1) * limit + 1
  const endItem = Math.min(currentPage * limit, totalItems)

  return (
    <div className='flex flex-col items-center px-5 py-2'>
      <h2 className='text-[18px] font-semibold self-start'>My Subscriptions</h2>
      <div className='w-full mt-4 border border-gray-200 rounded-lg overflow-hidden shadow-md'>
        {loading ? (
          <div className='text-center py-5 flex justify-center items-center'>
            <Loader />
          </div>
        ) : (
          <table className='w-full text-left text-sm text-gray-700'>
            <thead className='bg-gray-100'>
              <tr>
                <th className='px-4 py-2'>Plan</th>
                <th className='px-4 py-2'>Status</th>
                {/* <th className='px-4 py-2'>Provider</th> */}
                <th className='px-4 py-2'>Start Billing</th>
                <th className='px-4 py-2'>Next Billing</th>
                <th className='px-4 py-2'>Price</th>
                <th className='px-4 py-2'>Frequency</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.length > 0 ? (
                subscriptions.map(sub => (
                  <tr key={sub.id} className='border-t'>
                    <td className='px-4 py-2'>
                      {sub.subscriptionPlan?.name
                        ? (() => {
                            const parts = sub.subscriptionPlan.name
                              .split('][')
                              .map(p => p.replace('[', '').replace(']', ''))
                            const lastPart = parts[parts.length - 1]
                            return lastPart === 'Free Plan'
                              ? 'Free Trial Plan'
                              : lastPart || 'N/A'
                          })()
                        : 'N/A'}
                    </td>

                    <td className='px-4 py-2 capitalize flex items-center gap-2'>
                      <span
                        className={`w-2.5 h-2.5 rounded-full ${
                          sub.status === 'active'
                            ? 'bg-green-500'
                            : 'bg-red-500'
                        }`}
                      ></span>
                      {sub.status}
                    </td>

                    {/* <td className='px-4 py-2 capitalize'>{sub.provider}</td> */}
                    <td className='px-4 py-2'>
                      {new Date(sub.startDate).toLocaleDateString('en-GB')}
                    </td>
                    <td className='px-4 py-2'>
                      {sub.subscriptionPlan.frequencyType === 'onetime'
                        ? '—'
                        : new Date(sub.endDate).toLocaleDateString('en-GB')}
                    </td>
                    <td className='px-4 py-2'>
                      {sub.subscriptionPlan.price === 0
                        ? sub.subscriptionPlan.price
                        : `$${sub.subscriptionPlan.price}`}
                    </td>
                    <td className='px-4 py-2'>
                      {sub.subscriptionPlan.frequencyType === 'month'
                        ? 'Month'
                        : 'One-Time'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan='6'
                    className='px-4 py-2 text-center text-gray-500'
                  >
                    No subscription logs found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div className='flex justify-between items-center w-full p-3'>
        <span className='font-[600] text-[12px]'>
          {totalItems > 0 ? `${startItem} - ${endItem} of ${totalItems}` : '0'}
        </span>

        <div className='flex items-center'>
          <button
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
            className='p-2'
          >
            &lt; {/* Left Arrow */}
          </button>
          <span className='mx-2 font-[600] text-[12px]'>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
            className='p-2'
          >
            &gt; {/* Right Arrow */}
          </button>
        </div>
      </div>
    </div>
  )
}

export default LogsComponent
